export const getStatusVariant = (status: string) => {
  switch (status) {
    case "PROCESSED":
      return "default";
    case "PENDING":
      return "secondary";
    case "FAILED":
      return "destructive";
    case "UNMATCHED_DRUGS":
      return "outline";
    default:
      return "outline";
  }
};

export const getDocumentTypeVariant = (documentType?: string | null) => {
  switch (documentType) {
    case "Mental health":
      return "default";
    case "Men's health":
      return "secondary";
    case "Women's health":
      return "outline";
    default:
      return "outline";
  }
};

export const getPaymentStatusVariant = (status?: string | null) => {
  switch (status) {
    case "PAID":
    case "CAPTURED":
      return "active"; // Green variant
    case "PENDING":
      return "secondary";
    case "FAILED":
      return "destructive"; // Red variant
    default:
      return "outline";
  }
};
